<template>
    <div class="courseCard" v-if="loader">

        <div class="courseCard__tutors"
        v-if="user.permissions.includes('CURSOS_FILTRAR_TUTOR')"
        >
            <div class="courseCard__tutors__chip" @mouseover="showTooltip = true" @mouseout="showTooltip = false">
                <i class="material-icons">how_to_reg</i>
                <span>{{ course.tutors.length }}</span>
            </div>
            <div class="courseCard__tutors__tooltip" v-show="showTooltip">
                <h5>{{$t('course.card.TUTORS')}}</h5>
                <ul>
                    <!-- <li>María Perez</li> -->
                    <!-- print course.tutor -->
                    <li
                    v-for="tutor in course.tutors"
                    :key="tutor"
                    >{{ tutor }}</li>
                </ul>
            </div>
        </div>
        
        <div class="courseCard__img" :style="{'background-image': `url(${course.image})`}" >
            <template v-if="course.type !== 'ON_DEMAND'">
                <span v-if="isFinished && course.canCertificate !== null" :class="`courseCard__pill--${course.canCertificate}`"> {{ $t(`course.card.pill.${course.canCertificate}`) }} <i class="material-icons">check_circle</i></span>
            </template>
        </div>
        <div class="courseCard__data">
            <h5>{{course.name}}</h5>
            <span v-if="course.endDate">
                {{ isFinished ? $t('course.card.FINISHED_DATE', { date: formatDate(course.endDate) }) : $t('course.card.FINISH_DATE', { date: formatDate(course.endDate) }) }}
            </span>
            <span v-else style="opacity: 0;">{{$t('course.card.NO_END_DATE')}}</span>
        </div>
        <p  class="courseCard__description" >{{ course.description }}</p>
        <div :style="{display: 'flex', flexDirection: 'column', gap: '14px', justifySelf: 'flex-end'}">
            <div :style="{display: 'flex', alignItems: 'center', gap: '15px'}">
                <a v-if="!isFinished" class="courseCard__button" @click="router.push(`/course/${course.id}`)">{{ $t('course.card.CONTINUE') }}<i class="material-icons">arrow_forward</i></a>
                <a v-else class="courseCard__button--finished" @click="router.push(`/course/${course.id}`)">{{$t('course.card.SEE_DETAIL')}}<i class="material-icons">arrow_forward</i></a>
                <span class="courseCard__code">{{ course.code }}</span>
            </div>
            <div v-if="!isFinished && course.progressBar !== null"  class="courseCard__progressBar" :style="{'width': `${course.progressBar}%`}"></div>
        </div>
    </div>

    <div v-else class="courseCard">
        <div class="courseCard__img"><Skeletor width="100%" height="100" /></div>
        <div class="courseCard__data">
            <h5><Skeletor  width="60%"/></h5>
            <span><Skeletor width="30%" /></span>
        </div>
        <div>
            <Skeletor height="160%" width="60%" pill style="background-color: #009696; opacity:0.3" />
        </div>
    </div>

</template>

<script>
import { ref } from 'vue';
import { inject } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router'
import { Skeletor } from 'vue-skeletor';
import { computed } from '@vue/reactivity';
import { useI18n } from 'vue-i18n';



export default {
    props: ['course', 'loader',  'isFinished'],
    components: {
        Skeletor  
    },
    setup(){
        const formatDate = inject('formatDate')
        const router = useRouter();
        const route = useRoute();
        const store = useStore();
        const { t } = useI18n();

        const user = computed(() => store.getters.manageUser_user);
        const showTooltip = ref(false);


        

        return {
            formatDate,
            router,
            route,
            showTooltip,
            user,
            t
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/styles/main.scss";
@import '~vue-skeletor/dist/vue-skeletor.css';


.courseCard{
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
        min-width: 320px;
        max-width: 320px;
        min-height: 260px;
        display: flex;
        flex-direction: column;
        padding: 14px;
        border-radius: 10px;
        position: relative;
        
        &__code{
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            color: #b4b4b4;
            text-overflow: ellipsis;
            overflow: hidden;
            text-wrap: nowrap;
            width: 40%;
        }
        &__pill{
            position: absolute;
            background-color: #fff;
            display: flex;
            align-items: center;
            gap: 6px;
            font-size: 11px;
            font-weight: 600;
            padding: 4px 8px;
            top: 11px;
            right: 16px;
            border-radius: 4px;
            .material-icons{
                font-size: 16px;
            }
            &--true{
                @extend .courseCard__pill;
                color: $green;
                .material-icons{
                    color: $green;
                }
            }
            &--false{
                @extend .courseCard__pill;
                color: $red;
                .material-icons{
                    color: $red;
                }
            }
        }
        .courseCard__data{
            margin: 16px 0 12px 0;
            h5{
                font-weight: 700;   
                font-size: 18px;
                color: $black;
                height: 50px;
                max-height: 50px;
            }
            span{
                font-weight: 600;
                font-size:12px;
                color: $black;
            }
        }
        
        .courseCard__button{
            background-color: $green;
            color: #fff;
            border-radius: 99999px;
            padding: 12px 28px;
            width: fit-content;
            display: flex;
            align-items: center;
            gap: 8px;
            line-height: 17px;
            &--end{
                @extend .courseCard__button;
                align-self: flex-end;
            }
            &--finished{
                padding: 8px 24px;
                padding-left: 0;
                display: flex;
                align-items: center;
                color: $green;
                gap: 6px;
                font-weight: 600;
                i{
                    font-size: 18px;
                }
            }
            .material-icons{
                font-size: 18px;
            }
        }
        .courseCard__img{
            position: relative;
            border-radius: 10px;
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
            height: 50%;
            min-height: 110px;
            height: 130px;
            p{
                padding: 8px 16px;
                margin: 4px;
                background-color: #fff;
                color: $green;
                border-radius: 4px;
                width: fit-content;
                font-size: 11px;
                font-weight: 600;
            }
        }

        .courseCard__tutors {
            &__chip {
                display: inline-flex;
                padding: 0 12px;
                align-items: center;
                justify-content: center;
                height: 30px;
                border-radius: 20px;
                gap: 2px;
                font-size: 11px;
                font-weight: 700;
                line-height: 15px;
                letter-spacing: 0em;
                text-align: left;
                background-color: #D5FBFB;
                position: absolute;
                right: 24px;
                top: 24px;
                z-index: 5;
                .material-icons {
                    font-size: 16px;
                }
            }

            &__tooltip {
                position: absolute;
                right: 24px;
                top: 40px;
                background-color: #BDE4E4;
                box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
                border-radius: 10px;
                padding: 12px;
                z-index: 1;
                width: 133px;
                top: 58px;
                border-radius: 10px;


                h5 {
                    font-size: 12px;
                    font-weight: 700;
                    line-height: 15px;
                    letter-spacing: 0em;
                    text-align: left;
                    color: #212121;
                }
                ul {
                    list-style: none;
                    padding: 0;
                    margin: 0;
                    li {
                        font-size: 11px;
                        font-weight: 400;
                        line-height: 18px;
                        letter-spacing: 0em;
                        text-align: left;
                        color: #212121;
                        margin-bottom: 4px;
                    }
                }
            }
        }

        &__description{
            font-weight: 400;
            font-size: 12px;
            line-height: 18px;
            color: map-get($dark , 600 );
            margin-bottom: 12px;
            height: 36px;
            max-height: 36px;

            display: -webkit-box;
            -webkit-line-clamp: 2;
            overflow: hidden;
            white-space: pre-wrap;
            -webkit-box-orient: vertical;
        }
        &__progressBar{
            height: 8px;
            background: linear-gradient(270deg, #009696 0%, #DDDDDD 100%);
            border-radius: 40px;
        }
    }
</style>